import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../hybrid/wrappers';
import { generateGridStyles } from '../components/helpers';

const Check = ({ val, getHandlers, gridStyles, name }) => {
    const { stylers, classes, existSt } = generateGridStyles(gridStyles, name);
    if (Boolean(val)) {
        return (
            <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
                {svgSprite('check', {
                    style: existSt('ico') || {
                        fill: 'var(--greenDeepColor)',
                        width: '15px',
                        height: '10px'
                    },
                    className: classes.ico
                })}
            </p>
        );
    }
    return (
        <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
            {svgSprite('plus', {
                style: existSt('ico') || {
                    fill: 'var(--greyExtraDarkColor)',
                    width: '15px',
                    height: '15px'
                },
                className: classes.ico
            })}
        </p>
    );
};
Check.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Check;
